import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.95, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "", innerClassName = "" }) => (
  <motion.span
    className={`block overflow-hidden ${className}`}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
  >
    <motion.span
      className={`block ${innerClassName}`}
      variants={{ hidden: { y: "115%" }, show: { y: "0%" } }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </motion.span>
);

export const Eyebrow = ({ index, label, tone = "gold" }) => (
  <div className="flex items-center gap-4" data-testid={`eyebrow-${label.toLowerCase().replace(/\s+/g, "-")}`}>
    <span className="font-mono text-xs text-gold tracking-widest">{index}</span>
    <span className={`h-px w-10 ${tone === "gold" ? "bg-gold/60" : "bg-cream/40"}`} />
    <span className="font-mono text-xs uppercase tracking-[0.3em] text-cream/60">{label}</span>
  </div>
);

export { EASE };
